import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { environment } from 'apps/stock/src/environments/environment';

@Component({
    selector: 'rewards',
    templateUrl: './rewards.component.html',
    styleUrls: ['./rewards.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RewardsComponent extends DialogFullScreenComponentContent {
    public isNewBrand = environment.isNewBrand;

    constructor(
        private dialogReference: MatDialogRef<RewardsComponent>,
        public element: ElementRef,
        public store: Store<AppState>) {
        super(element, '.overlay-graphic');
        this.displayBipChat(false);
    }

    public dispose() {
        super.close(this.dialogReference, null);
        this.displayBipChat(true);
    }

    public openStore(): void {
        this.trackingMixpanel({
            action: 'User Clicked',
            element: 'btn-store-rewards',
        });
    }

    /**
    * Trackear mixpanel: fluxo platform
    */
    private trackingMixpanel(events: any): void {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: 'Rewards Gift Button',
                events,
            },
        });
    }

    private displayBipChat(show: boolean): void {
        const iFrames = Array.from(window.document.getElementsByTagName('iframe'));

        const blipChat = iFrames.find(iframe => iframe.title === 'Botão para abrir a janela de mensagens')

        if (blipChat) blipChat.style['display'] = show ? 'block' : 'none';
    }
}
